/// <reference path='./graphql.d.ts' />

import getGlossData from './getGlossData';
import getGlossVersion from './getGlossVersion';

export const getGlossDataQuery = getGlossData;
export const getGlossVersionQuery = getGlossVersion;
